module.exports = __webpack_public_path__ + "static/media/OSK_5_35.4516f59b.png";